// src/config.ts

// Petit helper pour éviter de répéter "as string" partout et gérer les "undefined"
const getEnv = (key: string, defaultValue: string = ''): string => {
  // On dit à TS : "Fais-moi confiance, c'est une string ou undefined, et si c'est vide, prends la défaut"
  return (import.meta.env[key] as string) || defaultValue;
};

// --- Utilisation ultra propre ---

export const NODE_ENV = import.meta.env.MODE; // Vite fournit MODE par défaut, pas besoin de hack
export const VITE_LOG_LEVEL = getEnv('VITE_LOG_LEVEL', 'WARN');

export const VITE_API_ENDPOINT = getEnv('VITE_API_ENDPOINT', 'https://api.perfectpost.social/v1');
export const VITE_CHATKIT_ENDPOINT = getEnv('VITE_CHATKIT_ENDPOINT');

export const VITE_COGNITO_IDENTITY_POOL_ID = getEnv('VITE_COGNITO_IDENTITY_POOL_ID');
export const VITE_COGNITO_USER_POOL_ID = getEnv('VITE_COGNITO_USER_POOL_ID');
export const VITE_COGNITO_USER_POOL_WEB_CLIENT_ID = getEnv('VITE_COGNITO_USER_POOL_WEB_CLIENT_ID');

export const VITE_LINKEDIN_REDIRECT_URI = getEnv('VITE_LINKEDIN_REDIRECT_URI');
export const VITE_LINKEDIN_CLIENT_ID = getEnv('VITE_LINKEDIN_CLIENT_ID');
export const VITE_LINKEDIN_STATE = getEnv('VITE_LINKEDIN_STATE');
export const VITE_LINKEDIN_SCOPE = getEnv('VITE_LINKEDIN_SCOPE');

// Cas particulier : undefined possible -> on caste directement sans helper
export const VITE_EXTENSION_MIN_VERSION = import.meta.env.VITE_EXTENSION_MIN_VERSION as string | undefined;

export const VITE_STRIPE_PUBLIC_KEY = getEnv('VITE_STRIPE_PUBLIC_KEY');
export const VITE_STRIPE_PREMIUM_MONTHLY_PRICE_ID = import.meta.env.VITE_STRIPE_PREMIUM_MONTHLY_PRICE_ID as
  | string
  | undefined;
export const VITE_STRIPE_PREMIUM_YEARLY_PRICE_ID = import.meta.env.VITE_STRIPE_PREMIUM_YEARLY_PRICE_ID as
  | string
  | undefined;
export const VITE_STRIPE_PREMIUM_MONTHLY_PRICE_ID_USD = import.meta.env.VITE_STRIPE_PREMIUM_MONTHLY_PRICE_ID_USD as
  | string
  | undefined;
export const VITE_STRIPE_PREMIUM_YEARLY_PRICE_ID_USD = import.meta.env.VITE_STRIPE_PREMIUM_YEARLY_PRICE_ID_USD as
  | string
  | undefined;

// Cas particulier : Number
export const VITE_LIST_MAX_MEMBER = import.meta.env.VITE_LIST_MAX_MEMBER
  ? parseInt(import.meta.env.VITE_LIST_MAX_MEMBER as string, 10)
  : 28;

// Cas particulier : Boolean
export const VITE_NO_EXTENSION_CHECK = (import.meta.env.VITE_NO_EXTENSION_CHECK as string) === 'true';

export const VITE_SHORTURL_ENDPOINT = getEnv('VITE_SHORTURL_ENDPOINT');
export const VITE_MIXPANEL_TOKEN = getEnv('VITE_MIXPANEL_TOKEN');
export const VITE_BUILD_HASH = getEnv('VITE_BUILD_HASH');

export const VITE_NOTION_CLIENT_ID = getEnv('VITE_NOTION_CLIENT_ID');
export const VITE_NOTION_REDIRECT_URI = getEnv('VITE_NOTION_REDIRECT_URI');

export const VITE_GOOGLE_CLIENT_ID = getEnv('VITE_GOOGLE_CLIENT_ID');
export const VITE_GOOGLE_REDIRECT_URI = getEnv('VITE_GOOGLE_REDIRECT_URI');
export const VITE_GOOGLE_SCOPE = getEnv('VITE_GOOGLE_SCOPE');

export const VITE_MICROSOFT_CLIENT_ID = getEnv('VITE_MICROSOFT_CLIENT_ID');
export const VITE_MICROSOFT_REDIRECT_URI = getEnv('VITE_MICROSOFT_REDIRECT_URI');
export const VITE_MICROSOFT_SCOPE = getEnv('VITE_MICROSOFT_SCOPE');

export const VITE_CANVA_CLIENT_ID = getEnv('VITE_CANVA_CLIENT_ID');
export const VITE_CANVA_REDIRECT_URI = getEnv('VITE_CANVA_REDIRECT_URI');
export const VITE_CANVA_SCOPE = getEnv('VITE_CANVA_SCOPE');

export const VITE_ENV = getEnv('VITE_ENV');
